import { FileDoc } from '@phosphor-icons/react';

export default FileDoc;
